import { render, staticRenderFns } from "./ExperienceIndustry.vue?vue&type=template&id=84637096"
import script from "./ExperienceIndustry.vue?vue&type=script&lang=js"
export * from "./ExperienceIndustry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports